<div tabindex="0" #focusableElement class="attachment-container">
  <ul class="attachment-list" [class.hidden]="property.value?.length === 0">
    <li *ngFor="let attachment of property.value" class="attachment">
      <cc-popover placement="right" containerClass="sm-w-full" container="body">
        <button
          class="preview-attachment-button"
          type="button"
          (click)="viewAttachment(attachmentPreviewerModal, attachment)"
          trigger
        >
          <section class="attachment-name-container">
            <em class="cc-icon cc-icon-file-pdf"></em>
            <a class="sm-line-clamp-1 sm-leading-5 sm-text-xs sm-underline">{{ attachment.filename }}</a>
          </section>
          <section class="attachment-controls-container">
            <button
              type="button"
              class="attachment-control sm-text-default-text hover:sm-text-black"
              (click)="$event.stopPropagation(); downloadAttachment(attachment)"
              title="Download attachment"
            >
              <em class="cc-icon cc-icon-download"></em>
            </button>
            <button
              type="button"
              class="attachment-control sm-text-default-red hover:sm-text-secondary-red"
              (click)="$event.stopPropagation(); deleteAttachment(attachment)"
              title="Delete attachment"
            >
              <em class="cc-icon cc-icon-delete icon-bump-1px-up"></em>
            </button>
          </section>
        </button>
        <aside class="attachment-controls-modal" content>
          <p>{{ attachment.filename }}</p>
        </aside>
      </cc-popover>
    </li>
  </ul>

  <button class="add-attachment-button" type="button" (click)="addAttachment()">
    <em class="cc-icon cc-icon-plus"></em>
    <span>Attach PDF</span>
  </button>

  <ng-template #attachmentPreviewerModal let-close="close">
    <cc-list-attachments-previewer
      [attachments]="state.attachments"
      [selectedAttachment]="state.selectedAttachment"
      [downloading]="state.downloading"
      [editable]="editable"
      (delete)="onDeleteAttachment($event)"
      (download)="onDownloadAttachment($event)"
      (close)="close()"
    >
    </cc-list-attachments-previewer>
  </ng-template>
</div>
